/***************************************************************************************
 * @module       Main Routes 
 * @name         techus-mainRoutes
 * @description  Main application router configuration with authentication and protected routes
 * @version      1.0.0
 * @license      Licensed under the MIT License
 * @createdon    May 2025
 * @since        1.0
 ***************************************************************************************/

import React from 'react';
import { createHashRouter } from 'react-router-dom';
import userRoutes from './productedRoutes/techus-userRoutes';
import Login from '../components/AuthModule/Login';
import ResetPassword from '../components/AuthModule/ResetPassword';
import UnAuthRoute from '../utils/techus-UnautherizedRouteUtils';
import Logout from '../components/AuthModule/logout';
import { SessionHandler } from '../axois/SessionHandler';
const router = createHashRouter([
  {
    path: '/',
    element: <UnAuthRoute> <SessionHandler /><Login /></UnAuthRoute>,
    children: [
      { path: '/login', element: <Login />, index: true },
      { path: '*', element: <p>404 Error - Nothing here...</p> },
    ],
  },
  {
    path: '/logout',
    element: <SessionHandler> <Logout /> </SessionHandler>,
  },
  {
    path: '/reset_password',
    element:<><SessionHandler /> <ResetPassword /></> ,
  },
  ...userRoutes,
],
  { future: { v7_startTransition: true } }
);

export default router;
